// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gz-0";
export var headerCellHover = "_gz-1";
export var readCellContainer = "_gz-2";
export var unreadIndicator = "_gz-3";